export default () => {
  window.addEventListener('load', () => {
    window.setTimeout(() => {
      const body = document.querySelector("body.enable-chat");

      if (body) {
        // 3CX
        const callUsSelector = document.createElement("call-us-selector");
        callUsSelector.setAttribute("phonesystem-url", "https://banbury.3cx.co.nz:5001");
        callUsSelector.setAttribute("party", "LiveChat621268");
        body.appendChild(callUsSelector);

        const script = document.createElement("script");
        script.src = "https://downloads-global.3cx.com/downloads/livechatandtalk/v1/callus.js";
        script.defer = true;
        script.id = "tcx-callus-js";
        script.charset = "utf-8";
        body.appendChild(script);
        // end 3CX
      } else {
        console.warn("body.enable-chat not found");
      }

    }, 5000);
  });
}
